<template>
    <v-dialog
        v-model="addMemberCodeDialog"
        persistent
        width="500"
    >
        <template v-slot:activator="{ attrs }">
            <v-btn
                v-if="modelType==='Add'"
                class="ma-1 action-btn text-subtitle-2"
                depressed
                color="primary"
                v-bind="attrs"
                @click="openDialog"
            >
                <v-icon
                    left
                    class="action-icon"
                >
                    mdi-plus
                </v-icon>
                Add Member Code
            </v-btn>
            <v-icon
                v-if="modelType==='Edit'"
                class="cp"
                v-bind="attrs"
                @click="openDialog"
            >
                mdi-pencil
            </v-icon>
        </template>
        <v-card id="add_member_code_dialog">
            <v-card-title class="text-h5 lighten-2">
                <span v-if="modelType === 'Add'">Add Member Code</span>
                <span v-if="modelType === 'Edit'">Edit Member Code</span>
            </v-card-title>
            <v-divider />
            <v-card-text>
                <v-form
                    ref="form"
                    v-model="valid"
                >
                    <v-row class="mt-5">
                        <v-col
                            cols="12"
                            sm="12"
                            class="py-0"
                        >
                            <v-select
                                v-model="center_id"
                                :rules="centerRules"
                                :items="getMemberCodeCenter"
                                item-text="center_tag"
                                item-value="center_id"
                                label="Center"
                                dense
                                outlined
                                @change="refreshFacilityTypes"
                                
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            sm="12"
                            class="py-0"
                        >
                            <v-text-field
                                v-if="addMemberCodeDialog"
                                v-model="memberCode"
                                :rules="memberCodeRules"
                                label="Member Code"
                                outlined
                                dense
                                class="upper-case"
                                required
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="12"
                            class="py-0"
                        >
                            <v-textarea
                                v-if="addMemberCodeDialog"
                                v-model="description"
                                outlined
                                auto-grow
                                name="Description"
                                label="Description"
                                row-height="15"
                                :rules="descriptionRules"
                                required
                            />
                        </v-col>
                        <v-col 
                            v-if="useScreenLogix"
                            cols="12"
                            md="12"
                            class="py-0"
                        >
                            <v-text-field
                                v-if="addMemberCodeDialog"
                                v-model="screen_destination"
                                outlined
                                :rules="emailRules"
                                name="Delivery Destination"
                                label="Delivery Destination"
                                required
                            />
                        </v-col>
                        <v-col 
                            v-if="useScreenLogix"
                            cols="12"
                            md="12"
                            class="py-0"
                        >
                            <v-select
                                v-model="screen_delivery_format"
                                :items="deliveryFormats"
                                item-text="name"
                                item-value="value"
                                label="Delivery Format"
                                dense
                                outlined
                                required
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="12"
                            class="py-0 checkbox-container"
                        >
                            <v-checkbox
                                v-if="hasCenter811Response"
                                v-model="send_pr_center"
                                label="Send Positive Response to Center"
                                class="py-0 my-0"
                            />
                            <v-checkbox
                                v-if="hasExcavatorResponse"
                                v-model="send_pr_excavator"
                                label="Send Positive Response to Excavator"
                                class="py-0 my-0"
                            />
                        </v-col>
                    </v-row>
                    <v-divider class="my-4" />
                    <div class="facility_types">
                        Facility Types
                    </div>
                    <v-row class="mt-5">
                        <v-col
                            v-for="item in facilityTypes"
                            :key="item"
                            cols="6"
                            md="6"
                            class="py-0 checkbox-container"
                        >
                            <v-checkbox
                                v-model="facilityTypesModel[item]"
                                :label="`${capitalized(item)}`"
                                class="py-0 my-0"
                            />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <DeleteMemberCode
                    v-if="modelType==='Edit'"
                    model-type="DeleteBtn"
                    :member-code="memberDetails"
                    @closed-dialog="closedDialog"
                />
                <v-spacer />
                <v-btn
                    style="text-transform: none !important;"
                    outlined
                    light
                    @click="closedDialog"
                >
                    Cancel
                </v-btn>
                <v-btn
                    style="text-transform: none !important"
                    depressed
                    color="primary"
                    :disabled="!formValid"
                    @click="save"
                >
                    <span v-if="modelType==='Add'">Add</span>
                    <span v-if="modelType==='Edit'">Update</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

import _ from 'lodash';
import webtmsBackend from '@/services/webtmsBackend';
import DeleteMemberCode from './DeleteMemberCode';
import { hasPermission } from '../../../utils/permissions';

export default {
    name: 'AddMemberCode',    
    components: {
        DeleteMemberCode
    },
    props: {
        modelType: {
            type: String,
            required: true
        },
        memberDetails: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },
    data: () => ({
        valid: true,
        cid: null,
        center_id: null,
        formValid: false,
        centerRules: [
            v => !!v || 'Center is required',
        ],
        description: null,
        descriptionRules: [
            v => !!v || 'Description is required',
        ],
        memberCode: null,
        memberCodeRules: [
            v => /^[A-Za-z0-9\-*:#]+$/.test(v) || 'Member code required and must be valid',
        ],
        send_pr_center: false,
        send_pr_excavator: false,
        facility_type: '',
        addMemberCodeDialog: false,
        facilityTypes: [],
        facilityTypesModel: {},
        screen_destination: '',
        screen_delivery_format: null,        
    }),   
    computed: {
        getSystemVariable() {
            return this.$store.getters.systemVariables;
        },
        getMemberCodeCenter() {
            return this.$store.getters.companyCenters;
        },
        getAllCenters() {
            return this.$store.getters.centers;
        },
        hasExcavatorResponse() {
            return hasPermission('EXCAVATOR_RESPONSE');
        },
        hasCenter811Response() {
            return hasPermission('CENTER811_RESPONSE');
        },
        useScreenLogix() {
            return hasPermission('USE_SCREEN_LOGIX');
        },
        emailRules() {
            return [
                value => {
                    if (value) return true;
                    return 'E-mail is required.';
                },
                value => {
                    if (/.+@.+\..+/.test(value)) return true;
                    return 'E-mail must be valid.';
                },
                value => {
                    if (value && value.length <= 50) return true;
                    return 'E-mail must be less than or equal to 50 characters.';
                }
            ];
        },
        deliveryFormats() {
            return this.getDeliveryFormat();
        }
    },
    watch: {
        memberCode() {
            this.validateForm();
        },
        description() {
            this.validateForm();
        },
        center_id() {
            this.validateForm();
        },
        screen_destination() {
            if(this.useScreenLogix) {
                this.validateForm();
            }            
        },
        screen_delivery_format() {
            if(this.useScreenLogix) {
                this.validateForm();
            }            
        }
    },
    methods: {
        capitalized(title) {
            return _.capitalize(title);
        },
        closedDialog() {
            this.refreshVariables();
            this.addMemberCodeDialog = false;
        },
        validateForm() {
            if (this.useScreenLogix) {
                this.formValid = this.memberCode && this.description && this.center_id && this.screen_destination && this.screen_delivery_format;
            } else {
                this.formValid = this.memberCode && this.description && this.center_id;
            }
        },
        refreshFacilityTypes() {
            let center = this.getAllCenters.find(item => item.center_id === this.center_id);
            console.log(center);
            if(center) {
                this.facilityTypes = center.facility_types.map(item => item.facility_type);
                console.log(this.facilityTypes);
                this.facilityTypesModel = {};
                this.facilityTypes.forEach(item => {
                    this.facilityTypesModel[item] = false;
                });
            } else {
                this.facilityTypes = [];
                this.facilityTypesModel = {};
            }
        },
        refreshVariables() {
            this.center_id = null;
            this.description = null;
            this.memberCode = null;
            this.send_pr_center = false;
            this.send_pr_excavator = false;
            this.screen_destination = null;
            this.screen_delivery_format = null;
            this.memberCodeRules = [
                v => /^[A-Za-z0-9\-*:#]+$/.test(v) || 'Member code required and must be valid',
            ];
            this.centerRules = [
                v => !!v || 'Center is required',
            ];
            this.descriptionRules = [
                v => !!v || 'Description is required',
            ];
            this.valid = false;
        },
        openDialog() {
            this.addMemberCodeDialog = true;
            this.refreshVariables();

            if(this.$store.getters.company) {
                this.cid = this.$store.getters.company.cid;
            }

            if(this.memberDetails) {
                this.center_id = this.memberDetails.center_id;
                this.description = this.memberDetails.description;
                this.memberCode = this.memberDetails.member_code;
                this.send_pr_center = this.memberDetails.send_pr_center;
                this.send_pr_excavator = this.memberDetails.send_pr_excavator;
                this.screen_destination = this.memberDetails.screen_destination;
                this.screen_delivery_format = this.memberDetails.screen_delivery_format;
                this.refreshFacilityTypes();
                if(this.memberDetails.facility_type) {
                    let facility_type = this.memberDetails.facility_type.split(',');
                    Object.keys(this.facilityTypesModel).map(key => {
                        if(facility_type.includes(key)) {
                            this.facilityTypesModel[key] = true;
                        }
                    });
                }
            }
        },
        async save() {
            let facility_type = Object.keys(this.facilityTypesModel).filter(key => {
                return this.facilityTypesModel[key];
            }).join(',');
            let data = {
                center_id: this.center_id,
                cid: this.cid,
                description: this.description.toUpperCase(),
                facility_type: facility_type,
                memberCode: this.memberCode.toUpperCase(),
                send_pr_center: this.send_pr_center,
                send_pr_excavator: this.send_pr_excavator,
                screen_destination: this.screen_destination ? this.screen_destination.toUpperCase() : null,
                screen_delivery_format: this.screen_delivery_format ? this.screen_delivery_format.toUpperCase() : null
            };
            if(this.modelType === 'Add') {
                let result = await webtmsBackend.addMemberCode({ ...data });
                if(result.status === 'OK') {
                    this.$store.commit('SET_COMPANY_MEMBER_CODES', result.memberCodes);
                    this.closedDialog();
                    this.$store.dispatch('setSnackbar', { text: 'Member code added successfully!' });
                }
                if(result.err) {
                    this.$store.dispatch('setSnackbar', { color:'error', text: result.err });
                }
            } else {
                let result = await webtmsBackend.editMemberCode({ ...data });
                if(result.status === 'OK') {
                    this.$store.commit('SET_COMPANY_MEMBER_CODES', result.memberCodes);
                    this.closedDialog();
                    this.$store.dispatch('setSnackbar', { text: 'Member code updated successfully!' });
                }
                if(result.err) {
                    this.$store.dispatch('setSnackbar', { color:'error', text: result.err });
                }
            }

        },
        getDeliveryFormat(){

            let formats = [
                {name: 'Text', value: 'TEXT'},
                {name: 'Original Transmission', value: 'ORIGINAL'}
            ];
            return formats;
            // let result = await webtmsBackend.getDeliveryFormat();
            // if(result.status === 'OK') {
            //     return result.deliveryFormat;
            // }
            // if(result.err) {
            //     this.$store.dispatch('setSnackbar', { color:'error', text: result.err });
            // }
        }

    }
};
</script>
<style>
    #add_member_code_dialog .v-input--selection-controls__input {
        height: 16px;
        width: 16px;
    }
    .checkbox-container .v-label {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.0025em;
    }
    .checkbox-container .v-input__slot {
        margin: 0px;
    }
    .facility_types {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: var(--ll-text-primary);
    }
    .upper-case input, .upper-case textarea {
        text-transform: uppercase;
    }
    .delete-btn {
        text-transform: none !important;
        border: none !important;
        color: #CB3D31 !important;
    }
</style>
